import { FlightCardTypes } from "../../../enum/flights/FlightEnum";

type BuffersType = {
  departureEarlyBuffer?: string | number;
  departureLateBuffer?: string | number;
  arrivalEarlyBuffer?: string | number;
  arrivalLateBuffer?: string | number;
  overallBuffer?: string | number;
};

type IKpiToolTipInfoProps = {
  Buffers: BuffersType;
  bufferName: FlightCardTypes;
};

const renderDeparture = (
  Buffers: BuffersType,
  earlyKey: keyof BuffersType,
  lateKey: keyof BuffersType,
  beforeLabel: string,
  afterLabel: string
) => (
  <>
    <b>Departures:</b> % of flights departing{" "}
    {Buffers[earlyKey] !== "" && Buffers[earlyKey] !== undefined ? (
      <>
        within <b>{Buffers[earlyKey]} minutes</b> {beforeLabel} + % of flights
        departing within <b>{Buffers[lateKey]} minutes</b> {afterLabel}.
        <br />
      </>
    ) : (
      <>
        {beforeLabel} + % of flights departing within{" "}
        <b>{Buffers[lateKey]} minutes</b> {afterLabel}.
        <br />
      </>
    )}
  </>
);

const renderArrival = (
  Buffers: BuffersType,
  earlyKey: keyof BuffersType,
  lateKey: keyof BuffersType,
  beforeLabel: string,
  afterLabel: string
) => (
  <>
    <b>Arrivals:</b> % of flights arriving{" "}
    {Buffers[earlyKey] !== "" && Buffers[earlyKey] !== undefined ? (
      <>
        within <b>{Buffers[earlyKey]} minutes</b> {beforeLabel} + % of flights
        arriving within <b>{Buffers[lateKey]} minutes</b> {afterLabel}.
      </>
    ) : (
      <>
        {beforeLabel} + % of flights arriving within{" "}
        <b>{Buffers[lateKey]} minutes</b> {afterLabel}.
      </>
    )}
  </>
);

const renderDefaultDepartureArrival = (
  beforeLabel: string,
  afterLabel: string
) => (
  <>
    <b>Departures:</b> % of flights departing {beforeLabel} + % of flights
    departing {afterLabel}.
    <br />
    <b>Arrivals:</b> % of flights arriving {beforeLabel} + % of flights arriving{" "}
    {afterLabel}.
  </>
);

export const KpiToolTipInfo: React.FC<IKpiToolTipInfoProps> = ({
  Buffers,
  bufferName,
}) => {
  switch (bufferName) {
    case FlightCardTypes.OTP:
      return (
        <>
          On time performance by calculating the percentage of flights.
          <br />
          {renderDeparture(
            Buffers,
            "departureEarlyBuffer",
            "departureLateBuffer",
            "before SOBT",
            "after SOBT"
          )}
          {renderArrival(
            Buffers,
            "arrivalEarlyBuffer",
            "arrivalLateBuffer",
            "before SIBT",
            "after SIBT"
          )}
          <br />
        </>
      );
    case FlightCardTypes.SLOT_ADHERENCE:
      return (
        <>
          Measures Slot compliance by calculating the percentage of flights.
          <br />
          <b>Departures:</b> % of flights departing within{" "}
          <b>{Buffers.departureEarlyBuffer} minutes</b> before SOBT + % of
          flights departing within <b>{Buffers.departureLateBuffer} minutes</b>{" "}
          after SOBT.
          <br />
          <b>Arrivals:</b> % of flights arriving within{" "}
          <b>{Buffers.arrivalEarlyBuffer} minutes</b> before SIBT + % of flights
          arriving within <b>{Buffers.arrivalLateBuffer} minutes</b> after SIBT.
          <br />
        </>
      );
    case FlightCardTypes.TURNAROUND_SUFFICIENCY:
      return (
        <>
          Measures the percentage of linked turnaround flights completing
          {Number.isFinite(Buffers.overallBuffer) ? (
            <>
              {" "}
              within <b>{Buffers.overallBuffer} minutes</b> of the planned
              turnaround time.
            </>
          ) : (
            <> within planned turnaround time.</>
          )}
          <br />
        </>
      );
    case FlightCardTypes.REGULATED_FLIGHT:
      return (
        <>
          Regulated flights are those assigned a Calculated Take-Off Time
          (CTOT). This KPI indicates the share of flights planned under ATFM
          control to ensure smooth traffic flow and minimize runway congestion.
          <br />
        </>
      );
    case FlightCardTypes.ADDITIONAL_DELAY:
      return (
        <>
          This KPI shows the average delay time for linked flights.
          <br />
        </>
      );
    default:
      return <></>;
  }
};
